import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  let searchParameter = { ...sectionComponent.state.searchParameter };
  searchParameter[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    searchParameter['moduleId'] = parameter;
    sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
  }
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  let defaultFormData = { ...pageComponent.state.defaultFormData };
  defaultFormData[uie.source] = parameter;
  if (uie.source === 'ModuleId') {
    defaultFormData['moduleId'] = parameter;
  }
  if (uie.source === 'SystemUse') {
    defaultFormData['systemUse'] = parameter;
  }
  pageComponent.setState({ defaultFormData });

  let filterLoaded = true;
  sectionComponent.state.section.componentList.filter(c => c.type === 'View')[0].topFilterList[0].uieList.map((uie, i) => {
    if (componentDefaultValue[uie.source] === undefined) {
      filterLoaded = false;
    }
  })

  if (filterLoaded) {
    if (pageComponent.state.moduleId !== null) {
      defaultFormData['moduleId'] = parseInt(pageComponent.state.moduleId);
      searchParameter['ModuleId'] = parseInt(pageComponent.state.moduleId);
      componentDefaultValue['ModuleId'] = parseInt(pageComponent.state.moduleId);
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData, moduleId: null });
    }
     if (pageComponent.state.systemUse !== null) {
      defaultFormData['systemUse'] = pageComponent.state.systemUse === 'true' ? true : false;
      searchParameter['SystemUse'] = pageComponent.state.systemUse === 'true' ? true : false;
      componentDefaultValue['SystemUse'] = pageComponent.state.systemUse === 'true' ? true : false;
      sectionComponent.setState({ searchParameter, componentDefaultValue });
      pageComponent.setState({ defaultFormData, systemUse: null });
    }
    setTimeout(() => {
      sectionComponent.getSectionDataByDefault();
    }, config.setTimeoutMilliSecond);
  }
}

//通过 Favorite 修改 icon
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Favorite) {
      //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
      iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  console.log('AP', data);
  return data;
}

//更新 Favorite 状态
export function updateFavorite({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .put('Admin/ActionPack/UpdateFavorite', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}